import { cn } from '@repo/ui/lib/utils';
import { Button } from '../../../ui/button';
import { Checkbox } from '../../../ui/checkbox';
import {
  SearchInput,
  type SearchInputItem,
} from '../../search-input/component';
import React from 'react';
const SEARCHABLE_ITEM_COUNT = 6;
export type Item = {
  numberOfCandidates: number;
  value: string;
  label: string;
};
export const ItemFilter: React.FC<{
  onChange: (values: string[]) => void;
  values: Item[];
  featuredValues?: string[];
  selected: string[];
  unit: string;
}> = ({ onChange, values, selected, unit, featuredValues }) => {
  const handleSelectItem = (item: SearchInputItem | string) => {
    const itemValue = typeof item === 'string' ? item : item?.value;
    const isRemovingItem = selected.includes(itemValue);
    const newValues = isRemovingItem
      ? selected.filter((value) => value !== itemValue)
      : [...selected, itemValue];
    onChange(newValues);
  };
  const showSearch =
    values.length > SEARCHABLE_ITEM_COUNT && selected.length < values.length;
  const handleUnselectAllClick = () => onChange([]);
  const handleCheckboxChange = (item: Item) => handleSelectItem(item.value);

  return (
    <>
      {showSearch && (
        <SearchInput
          emptyResultsText={`No ${unit} found.`}
          selectedItemValues={selected}
          onSelectItem={handleSelectItem}
          items={values.map((n) => ({
            ...n,
            labelTrailingText: n.numberOfCandidates,
          }))}
        />
      )}

      <Button
        variant="link"
        className={cn('my-4 underline p-0 text-xs font-normal')}
        onClick={handleUnselectAllClick}
        disabled={selected?.length === 0}
        data-testid="unselect-all"
      >
        Unselect all
      </Button>

      {values
        .filter(
          (item) =>
            (featuredValues || []).concat(selected)?.includes(item.value) ||
            !showSearch,
        )
        .map((item, index) => {
          const isNotFirstItem = index > 0;
          return (
            <div
              key={index}
              className={cn('flex items-center space-x-2', {
                'mt-4': isNotFirstItem,
              })}
            >
              <Checkbox
                id={item.value}
                className="w-4 h-4 shadow-none"
                onCheckedChange={() => handleCheckboxChange(item)}
                checked={selected.includes(item.value)}
              />
              <label
                htmlFor={item.value}
                className="text-xs font-medium text-cn-foreground justify-between w-full flex"
              >
                {item.label}

                {item.numberOfCandidates && (
                  <span className="text-xs opacity-60">
                    {item.numberOfCandidates}
                  </span>
                )}
              </label>
            </div>
          );
        })}
    </>
  );
};
